import React, { useState } from 'react';
import {
  TextField,
  Button,
  Typography,
  Box,
 
} from '@mui/material';
import axios from 'axios';

const ProductDeleteSection = ({ showSnackbar }) => {
  const [offerId, setOfferId] = useState('');
  const [deleting, setDeleting] = useState(false);

  const deleteProduct = async () => {
    if (!offerId) {
      showSnackbar('⚠️ Please enter a valid Offer ID', 'warning');
      return;
    }

    setDeleting(true);
    try {
      await axios.post('/api/v1/google-merchant/delete-merchent-product', {
        offerIds: [offerId],
      });
      showSnackbar('✅ Product deleted successfully');
    } catch {
      showSnackbar('❌ Failed to delete product', 'error');
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Delete Product from Google Merchant</Typography>

      <TextField
        fullWidth
        label="Offer ID (e.g., product_430)"
        value={offerId}
        onChange={(e) => setOfferId(e.target.value)}
        sx={{ my: 2 }}
      />

      <Button
        variant="contained"
        color="error"
        onClick={deleteProduct}
        disabled={deleting}
      >
        {deleting ? 'Deleting...' : 'Delete Product'}
      </Button>
    </Box>
  );
};

export default ProductDeleteSection;
